import { ExMutationTree } from "vuex";
import { State, Mutations, Task } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  addTask(state, payload) {
    state.todos.push({
      id: state.nextTaskId,
      name: payload.name,
      done: false
    });
    state.nextTaskId++;
  },
  toggleTaskStatus(state, payload) {
    const filtered = state.todos.filter((task: Task) => {
      return task.id === payload.id;
    });
    filtered.forEach((task: Task) => {
      task.done = !task.done;
    });
  }
};

export default mutations;
